module.exports = __webpack_public_path__ + "img/华动高车.669a37ac.png";